export default __webpack_public_path__ + "static/media/animat-pencil-color.cf6fc4a0.gif";